import type { StarterChip } from "../lineHelpers";

// ---- LA LÍNEA DEL PROVEEDOR ----
// Espejo de `backend/src/services/onboarding.service.ts`: si cambian de un lado
// y no del otro, el número del onboarding deja de cuadrar con el dashboard.
// Solo contratadas: con el contrato firmado, el ganador ya está comprando.
export const SUPPLIER_STAGES = ["CONTRATADO"];
export const SUPPLIER_AWARD_WINDOW_DAYS = 90;

// ---- CHIPS DE ARRANQUE ----
// Curados a mano, sin IA: un chip puede traer varios productos porque así se
// escriben en los expedientes ("acero" y "fierro" son la misma varilla).
export const SUPPLIER_STARTERS: StarterChip[] = [
  { label: "Cemento", products: [{ label: "cemento", term: "cemento" }] },
  {
    label: "Acero corrugado",
    products: [
      { label: "acero corrugado", term: "acero corrugado" },
      { label: "fierro corrugado", term: "fierro corrugado" },
    ],
  },
  { label: "Asfalto", products: [{ label: "asfalto", term: "asf" }] },
  {
    label: "Alquiler de maquinaria",
    products: [
      { label: "excavadora", term: "excavadora" },
      { label: "cargador", term: "cargador" },
      { label: "volquete", term: "volquete" },
      { label: "rodillo", term: "rodillo" },
      { label: "motoniveladora", term: "motoniveladora" },
    ],
  },
  {
    label: "Agregados",
    products: [
      { label: "agregado", term: "agregad" },
      { label: "piedra chancada", term: "piedra chancada" },
      { label: "arena gruesa", term: "arena gruesa" },
    ],
  },
  { label: "Tuberías PVC", products: [{ label: "tubería pvc", term: "tubería pvc" }] },
];
